export default {"src":"/_next/static/media/required-installation-icon.eb963704.svg","height":16,"width":16};